import React, { Component } from "react";
import DataTable from "react-data-table-component";
import { trackPromise } from "react-promise-tracker";
import HabilitarAhorroProgramadoService from "../../../../services/autogestion/HabilitarAhorroProgramadoService";
import { formatoSeparadorMilesValue, splitImporte, formatoSeparadorMilesReturn } from "../../../generico/utils/FormatoInput";
import $ from "jquery";
import CuentaSocioTransferencia from "../../../generico/CuentaSocioTransferencia";
//src\components\generico\CuentaSocioTransferencia.js

import Popup from "react-popup";




export default class TuMetaEsLaNuestraPaso1 extends Component {
  TIPO_DEBITO = "D";
  TIPO_CREDITO = "C";

  constructor(props) {
    super(props);
    this.state = this.getInitialState();
  }
  initData = () => {

    this.resetState();
    this.getCuentas(this.TIPO_DEBITO);
    this.obtenerPlanesAhorro();
    this.continuar.disabled = true;
  };

  resetState = () => {
    this.setState(this.getInitialState());
    this.planSel = undefined;
  };

  getInitialState = () => ({
    cuentasOrigen: [],
    plan: {},
    listaPlan: [],
    planesList: [],
    ctaOrigenSele: { value: "-1", label: "--Seleccione--" },
    ctaFullData: {},
    monto: 0,
    nombre: '',
    montoFinal: 0,
    mostrarCalculo: false

  });

  componentDidMount() {
    this.initData();
  }

  onStepChange = (stats) => {
    if (stats.previousStep === 2) {
      this.paso1.current.checkGrilla();
    }
  };

  getListaPlan() {

    var respuesta = [];

    var items = this.state.planesList === null ? [] : this.state.planesList.datos;
    if (items !== null) {
      this.planHashmap = new Map();
      for (var i = 0; i < items.length; i++) {
        respuesta.push({
          id: items[i].idModalidad,
          numeroModalidad: items[i].numeroModalidad,
          saldoApertura: formatoSeparadorMilesValue(items[i].saldoApertura),
          saldoMinimo: formatoSeparadorMilesValue(items[i].saldoMinimo),
          descripcion: items[i].descripcion,
          interes: items[i].interes,
          plazo: items[i].plazo
        });
        this.planHashmap.set(items[i].idModalidad, items[i]);
      }
    }

    this.setState({ listaPlan: respuesta });
    return this.state.listaPlan;
  }

  getCuentas(tipo) {
    trackPromise(
      HabilitarAhorroProgramadoService.getCuentas(tipo).then((response) => {
        var data = JSON.stringify(response.data);
        var jsonData = JSON.parse(data);
        if (tipo === this.TIPO_DEBITO) {
          this.setState({ cuentasOrigen: jsonData.resultadoAH });
        } else if (tipo === this.TIPO_CREDITO) {
          this.setState({ cuentasDestino: jsonData.resultadoAH });
        }
      })
    );
  }

  obtenerPlanesAhorro(tipo) {
    trackPromise(
      HabilitarAhorroProgramadoService.obtenerPlanesAhorro().then((response) => {
        var data = JSON.stringify(response.data);
        var jData = JSON.parse(data);
        console.log("jData: ", jData);
        if (jData.codigo != 0) {
          Popup.queue(this.notifiPopup("ATENCION!", jData.mensaje));
        } else {
          this.setState(
            { planesList: jData },
            this.getListaPlan
          );
        }

      })
    );
  }

  notifiPopup = (titulo, mensaje) =>
    Popup.register({
      title: titulo,
      content: mensaje,
      buttons: {
        right: [
          {
            text: "Aceptar",
            className: "success",
            action: function () {
              Popup.close();
            },
          },
        ],
      },
    })

  selPlanEvt = (e) => {
    this.planSel = e.currentTarget;
    var _monto = splitImporte(this.state.monto);
    if (parseInt(_monto) < this.planHashmap.get(parseInt(this.planSel.value)).saldoApertura) {
      this.invalidMonto = true;
    } else {
      this.invalidMonto = false;
      this.calcularMontoFinal(_monto, this.planSel.value);
    }
    this.setState(
      {
        invalidMonto: this.invalidMonto,
        mostrarCalculo: false
      },
      this.enableNext(_monto)
    );

  };

  calcularMontoFinal(monto, planSelValue) {
    var _monto = parseInt(monto);
    var _meses = this.planHashmap.get(parseInt(planSelValue)).plazo;
    var _interes = this.planHashmap.get(parseInt(planSelValue)).interes;
    var data = {
      cuota: _monto,
      plazo: _meses,
      tasaInteres: _interes

    }
    if (_monto !== undefined && _monto > 0 && _meses != undefined && _meses > 0) {

      trackPromise(
        HabilitarAhorroProgramadoService.getInteres(data)
          .then((response) => {

            var data = JSON.stringify(response.data);
            var jData = JSON.parse(data);

            if (jData !== undefined && jData.codigo !== null) {
              if (jData.codigo === 0) {
                this._montoFinal = (_monto * _meses) + jData.datos;
                this.montoFinal = formatoSeparadorMilesReturn({ target: { value: this._montoFinal } });
                this.setState(
                  {
                    montoFinal: this.montoFinal,
                    mostrarCalculo: true
                  }
                );
                
              } else {
                Popup.queue(this.notifiPopup("Atención", jData.mensaje));
              }
            } else {
              Popup.queue(this.notifiPopup("Atención", "Ocurrió un error inesperado. Intente de nuevo más tarde."));
            }
          })
      ).catch(function (error) {
        console.log(error)
        // this.btn.removeAttribute("disabled");
        Popup.queue(Popup.register({
          title: "Error Inesperado.",
          content: "Intenta volver a recargar esta página o no dudes en contactar con nosotros si el problema persiste.",
          buttons: {
            right: [
              {
                text: "Aceptar",
                className: "success",
                action: function () {
                  Popup.close();
                },
              },
            ],
          },
        }));
      });
      
    }
  }

  enableNext(monto) {
    const { ctaOrigenSele } = this.state;
    if (
      ctaOrigenSele.value !== undefined &&
      ctaOrigenSele.value !== "-1" &&
      this.planSel !== undefined &&
      monto !== undefined && monto !== 0 &&
      (parseInt(monto) >= this.planHashmap.get(parseInt(this.planSel.value)).saldoApertura)
    ) {
      this.continuar.disabled = false;
    } else {
      this.continuar.disabled = true;
    }
    this.checkGrilla();
  }

  checkGrilla() {
    if (this.planSel !== undefined) {
      $("#" + this.planSel.id).prop("checked", true);
    }
  }

  getColumn() {
    return [
      {
        cell: (row) => (
          <input
            ref={() => this.planSel}
            id={"radio_" + row.id}
            type="radio"
            key={row.id}
            name="rowRadio"
            value={row.id}
            onClick={this.selPlanEvt}
          ></input>
        ),
        width: "50px",
      },
      {
        name: "Plan",
        selector: "descripcion",
      },
      {
        name: "Saldo mínimo de apertura",
        selector: "saldoApertura"
      },
      {
        name: "Numero de Modaliidad",
        selector: "numeroModalidad",
        omit: true,
      },
      {
        name: "Saldo mínimo",
        selector: "saldoMinimo",
        omit: true,
      },
      {
        name: "Tasa de Interés (%)",
        selector: "interes"
      },
    ];
  }
  cuentaOrigenReturn = (ctaFullData, item) => {
    this.setState(
      {
        ctaFullData: ctaFullData,
        ctaOrigenSele: item, // Se actualiza el estado aquí
      },
      () => {
        //  Ahora enableNext() se ejecutará después de que ctaOrigenSele tenga su nuevo valor
        this.enableNext(splitImporte(this.state.monto));
      }
    );
  };


  seleccionarFila(row) {
    //pintarFilaSeleccionada("row-" + row.id)
    /// control de radio button
    var radio = document.getElementById("radio_" + row.id)
    radio.checked = true
    radio.click(this.selPlanEvt);
  }



  render() {
    return (

      <div>
        <div className="row">

          <div className="steps clearfix">
            <ul role="tablist">
              <div className="row">

              </div>
              <li role="tab" className="current">
                <span>
                  <div className="title">
                    <span className="number current">1</span>
                    <span className="title_text current">
                      Selección de Plan
                    </span>
                  </div>
                </span>
              </li>
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    <span className="number">2</span>
                    <span className="title_text">Datos de Verificación</span>
                  </div>
                </span>
              </li>
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    <span className="number">3</span>
                    <span className="title_text">Confirmación</span>
                  </div>
                </span>
              </li>
            </ul>

          </div>
        </div>

        {/* <div className="row">
          <div className="col-md-12">
                <CuentaSocioTransferencia
                  selectorValue={this.cuentaOrigenReturn.bind(this)}
                  operacion="DEBITO"
                  tipoCuenta="AHORRO_VISTA"
                  items={this.state.cuentasOrigen}
                  itemSelected={this.state.ctaOrigenSele}
                />
          </div>
        </div> */}

        <div className="row">
          <div className="col-md-12">
            <label className="input-label-bold">Plazo: *</label>
            <span style={{ color: "gray", fontStyle: "italic" }}> (Las tasas vigentes están sujetas a variaciones)</span>
            <DataTable
              noHeader={true}
              pagination={false}
              columns={this.getColumn()}
              data={this.state.listaPlan}
              dense={true}
              noDataComponent="No hay planes disponibles"
              responsive={true}
              striped={true}
              onRowClicked={(e) => this.seleccionarFila(e)}
              pointerOnHover
            />
          </div>
        </div>
        <br />
        <div className="col-md-12">
          <div className="col-md-6">
            <CuentaSocioTransferencia
              selectorValue={this.cuentaOrigenReturn.bind(this)}
              operacion="DEBITO"
              tipoCuenta="AHORRO_VISTA"
              items={this.state.cuentasOrigen}
              itemSelected={this.state.ctaOrigenSele}
            />
          </div>
        </div>
        <br />
        <div className="row">
          <div className="col-md-3">
            <label className="input-label-bold">Importe de la Cuota: *</label>
          </div>
          <div className="col-md-3">
            <div className="form-group">
              <input
                value={this.state.monto}
                type="text"
                maxLength="19"
                name="monto"
                className="form-control input-box"
                onChange={(evt) => {
                  var _monto = formatoSeparadorMilesReturn(evt);
                  if (_monto.length > 1 && _monto.substr(0, 1) === "0") {
                    _monto = _monto.substr(1);
                  }
                  if (this.planSel !== undefined) {
                    if (parseInt(splitImporte(_monto)) < this.planHashmap.get(parseInt(this.planSel.value)).saldoApertura) {

                      this.invalidMonto = true;
                      this.setState({
                        montoFinal: null
                      });
                    } else {
                      this.invalidMonto = false;
                      this.calcularMontoFinal(splitImporte(_monto), this.planSel.value);
                    }
                  }
                  this.setState({
                    monto: _monto,
                    invalidMonto: this.invalidMonto,
                    mostrarCalculo: false
                  });

                  this.enableNext(splitImporte(_monto));
                }}
              />
              {this.state.invalidMonto && (
                <span className="invalid-select">El monto debe ser igual o mayor al saldo de apertura</span>
              )}
            </div>
          </div>
          { }
        </div>
        {/* {this.state.mostrarCalculo && ( */}
        <div className="row">
          <div className="row col-md-12">
            <div className="col-md-3">
              <label className="input-label-bold">Importe Aproximado a Percibir:<br /> <span style={{ fontSize: 12, fontWeight: 500 }}>Sobre tasa vigente</span> </label>
            </div>
            <div className="col-md-3">
              <span> {this.state.montoFinal} GS.</span>
            </div>
          </div>
        </div>
        {/* )} */}

        <div className="row row-nombre-meta">
          <div className="col-md-3">
            <label className="input-label-bold">Nombre: </label>
          </div>
          <div className="col-md-3">
            <div className="form-group">
              <input
                value={this.state.nombre}

                maxLength="19"
                name="nombre"
                className="form-control input-box"
                onChange={(evt) => {

                  this.setState({
                    nombre: evt.target.value
                  });

                }}

              />

            </div>
          </div>

        </div>

        <hr />

        <div className="row">
          <div className="col-md-10">
            <div className="row">
              <label
                className="input-label-bold-obligatorio float-left">
                (*) Campos Obligatorios
                <br />
              </label>
            </div>
          </div>
          <div className="col-md-2">
            <div className="row float-right">
              <button
                ref={(button) => (this.continuar = button)}
                className="btn btn-cu-primary"
                onClick={() => {
                  var plan = this.planHashmap.get(parseInt(this.planSel.value));
                  this.props.returnDataPaso1(this.state.ctaFullData, plan, this.state.monto, this.state.montoFinal, this.state.nombre);
                  this.nextStep.click();
                }}>
                Continuar
              </button>
              <button hidden ref={(a) => (this.nextStep = a)} className="btn btn-cu-primary" onClick={this.props.nextStep} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}
